// src/components/Watermark.js

import React from "react";

const Watermark = ({ text = "SCREEN COPY RESTRICTED" }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-30deg)",
        fontSize: "5rem",
        color: "rgba(240, 11, 11, 0.5)",
        pointerEvents: "none",
        userSelect: "none",
        whiteSpace: "nowrap",
        zIndex: 0,
      }}
    >
      {text}
    </div>
  );
};

export default Watermark;
